import {AccountSubscriptionDto} from '@peachy/core-domain-pure'
import {useSubscriptionService} from '../../providers/AppServiceProvider'

export async function loadActiveSubscription (): Promise<AccountSubscriptionDto> {
    return useSubscriptionService().loadActiveSmeSubscription()
}
